module.exports = __webpack_public_path__ + "img/kekkila_logo.3e9dc294.png";